{
  "gps": {
    "title": "GPS Tracking",
    "liveTracking": "Live Tracking",
    "geofences": "Geofences",
    "reports": "Reports",
    "alerts": "Alerts",
    "soon": "Soon",
    "comingSoon": "Coming Soon",
    "reportsComingSoon": "Reports Feature Coming Soon",
    "reportsComingSoonMessage": "We're working on trip reports, route history, and analytics. Stay tuned!",
    "alertsComingSoon": "Alerts Feature Coming Soon",
    "alertsComingSoonMessage": "Real-time alerts and notifications will be available soon.",
    "geofencesComingSoon": "Geofences Feature Coming Soon",
    "geofencesComingSoonMessage": "Create and manage geographic boundaries for your vehicles.",
    
    "device": "Device",
    "devices": "Devices",
    "devicesCount": "Devices ({{count}})",
    "online": "Online",
    "offline": "Offline",
    "noLocationData": "No location data",
    "speed": "Speed",
    "course": "Course",
    "lastUpdate": "Last Update",
    "lastUpdated": "Last updated",
    "coordinates": "Coordinates",
    "deviceInfo": "Device Information",
    "imei": "IMEI",
    "makeModel": "Make/Model",
    "noData": "No data",
    "locationData": "Location Data",
    
    "vehicle": "Vehicle",
    "driver": "Driver",
    "registration": "Registration",
    
    "geofence": "Geofence",
    "createGeofence": "Create Geofence",
    "editGeofence": "Edit Geofence",
    "deleteGeofence": "Delete Geofence",
    "geofenceName": "Geofence Name",
    "description": "Description",
    "color": "Color",
    "active": "Active",
    "inactive": "Inactive",
    "polygon": "Polygon",
    "circle": "Circle",
    
    "trip": "Trip",
    "trips": "Trips",
    "route": "Route",
    "routes": "Routes",
    "summary": "Summary",
    "generateReport": "Generate Report",
    "selectDateRange": "Select Date Range",
    "selectDevice": "Select Device",
    "distance": "Distance",
    "duration": "Duration",
    "averageSpeed": "Average Speed",
    "maxSpeed": "Max Speed",
    "startLocation": "Start Location",
    "endLocation": "End Location",
    "engineHours": "Engine Hours",
    
    "alert": "Alert",
    "alertType": "Alert Type",
    "acknowledge": "Acknowledge",
    "acknowledged": "Acknowledged",
    "unacknowledged": "Unacknowledged",
    "allAlerts": "All Alerts",
    
    "geofenceEnter": "Geofence Enter",
    "geofenceExit": "Geofence Exit",
    "speedExceeded": "Speed Exceeded",
    "deviceOffline": "Device Offline",
    "deviceOnline": "Device Online",
    "ignitionOn": "Ignition On",
    "ignitionOff": "Ignition Off",
    "lowBattery": "Low Battery",
    "sosAlarm": "SOS Alarm",
    
    "noLicense": "No GPS License",
    "noLicenseTitle": "GPS Tracking Not Available",
    "noLicenseMessage": "Your company doesn't have active GPS licenses.",
    "noLicenseAction": "Please purchase GPS licenses to access real-time tracking features.",
    "viewPlans": "View Plans",
    "upgradeToPro": "Upgrade to GPS Tracking",
    "checkingAccess": "Checking GPS access...",
    
    "connected": "Connected",
    "disconnected": "Disconnected",
    "connecting": "Connecting",
    "reconnecting": "Reconnecting",
    
  "searchDevices": "Search devices, license plates, make/model...",
  "noDevicesFound": "No devices found",
  "tryDifferentSearch": "Try a different search term",
  "searchVehicles": "Search vehicles by plate, make, model...",
  "noVehiclesFound": "No vehicles found",
    
    "noDevices": "No Active GPS Devices",
    "noDevicesMessage": "Devices will appear here when they start reporting positions",
    "noGeofences": "No Geofences Created",
    "noGeofencesMessage": "Tap 'Create' to add your first geofence",
    "noReports": "No Reports Generated",
    "noReportsMessage": "Select a date range and generate a report to see data here",
    "noAlerts": "No Alerts",
    "noPendingAlerts": "No Pending Alerts",
    "allAlertsAcknowledged": "All alerts have been acknowledged",
    
    "loading": "Loading",
    "loadingGeofences": "Loading geofences...",
    "refreshing": "Refreshing",
    "syncing": "Syncing",
    "error": "Error",
    "success": "Success",
    "create": "Create",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "refresh": "Refresh",
    "filter": "Filter",
    
    "drawInstructions": "Tap on the map to add points to your polygon",
    "drawingMode": "Drawing Mode",
    "completePolygon": "Complete Polygon",
    "cancelDrawing": "Cancel",
    "minimumPoints": "A polygon must have at least 3 points",
    
    "geofenceCreated": "Geofence created successfully",
    "geofenceUpdated": "Geofence updated successfully",
    "geofenceDeleted": "Geofence deleted successfully",
    "confirmDelete": "Are you sure you want to delete this geofence?",
    
    "reportGenerated": "Report generated successfully",
    "exportPDF": "Export to PDF",
    "exportCSV": "Export to CSV",
    
    "alertAcknowledged": "Alert acknowledged successfully",
    "managedInAdmin": "Alert rules are managed in the Django Admin panel",
    
    "selectVehicle": "Select Vehicle",
    "noVehicleAssigned": "No vehicle assigned",
    "noVehicleLinked": "No vehicle linked to this device",
    "vehicleAssigned": "Vehicle assigned successfully",
    "vehicleUnassigned": "Vehicle unassigned successfully",
    "failedToAssignVehicle": "Failed to assign vehicle",
    "failedToUnassignVehicle": "Failed to unassign vehicle",
    "failedToLoadVehicles": "Failed to load vehicles",
    "unassignVehicle": "Remove Vehicle",
    "noVehiclesAvailable": "No vehicles available",
    "linkToVehicle": "Link to Vehicle",
    "linkVehicle": "Link Vehicle",
    "editVehicle": "Edit Vehicle",
    "deviceNotFound": "Device not found",
    "forceUpdate": "Force Update",
    "updating": "Updating...",
    "forceUpdateNote": "Syncs device data from the server",
    "deviceDataUpdated": "Device data updated successfully",
    "failedToUpdateDevice": "Failed to update device data",
    "vehicles": "Vehicles",
    "loadingVehicles": "Loading vehicles...",
    "updatedAt": "Updated",
    "contractTitle": "GPS Usage Contract",
    "contractSummary": "By accepting, you agree to the GPS tracking usage terms (data collection, responsibilities and privacy) as set out in the legal documentation.",
    "contractAccept": "Accept",
    "contractReject": "Cancel",
    "contractAccepting": "Accepting...",
    "contractAcceptError": "Failed to accept contract.",
    "contractVersion": "Version {{version}}, of {{date}}",
    "contractSummaryHeading": "Pre-acceptance summary",
    "contractFullHeading": "Full contract and Annex A",
    "contractCopyRecipient": "A PDF copy of the contract will be sent to {{email}} after Stripe confirms the payment."
  }
}

